(function () {
  'use strict';

  function messageForVariant(variant) {
    if (!variant) return '';

    if (Number(variant.inventory_quantity) > 0) {
      return 'Ready-made. Ships within 1 week.';
    }

    if (variant.inventory_policy === 'continue') {
      return 'Made to order. Please allow 3–4 weeks for production.';
    }

    if (variant.available === false) {
      return 'Sold out.';
    }

    return '';
  }

  function variantsForForm(form) {
    if (form.variantFulfillmentData) return form.variantFulfillmentData;

    var dataElement = form.querySelector(
      'script[data-type="product-variations-data"]'
    );

    if (!dataElement) return [];

    try {
      form.variantFulfillmentData = JSON.parse(dataElement.textContent);
    } catch (error) {
      form.variantFulfillmentData = [];
    }

    return form.variantFulfillmentData;
  }

  function selectedVariant(form) {
    var variantIdInput = form.querySelector('input[name="id"]');
    var variants = variantsForForm(form);

    if (!variantIdInput || !variantIdInput.value) return null;

    return variants.find(function (variant) {
      return String(variant.id) === String(variantIdInput.value);
    }) || null;
  }

  function updateStatus(form, variant) {
    if (!form) return;

    var status = form.querySelector('[data-variant-fulfillment-status]');
    if (!status) return;

    status.textContent = messageForVariant(variant || selectedVariant(form));
  }

  function initialize() {
    var forms = document.querySelectorAll(
      'form[data-node-type="commerce-add-to-cart-form"]'
    );

    forms.forEach(function (form) {
      if (!form.querySelector('[data-variant-fulfillment-status]')) return;

      updateStatus(form);

      form.addEventListener('change', function () {
        window.setTimeout(function () {
          updateStatus(form);
        }, 0);
      });

      form.addEventListener('click', function (event) {
        if (!event.target.closest('[data-node-type="add-to-cart-option-pill"]')) {
          return;
        }

        window.setTimeout(function () {
          updateStatus(form);
        }, 25);
      });
    });

    document.body.addEventListener('foundVariation', function (event) {
      if (!event.detail) return;
      updateStatus(event.detail.element, event.detail.variation);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
